import { z } from "zod";

import { userSchema } from "../../user/userSchema";

export enum RoleID {
  Student = 1,
  Teacher = 2,
}

export const adminDashUserSchema = userSchema.extend({
  email: z.string().email().nullable(),
  role_id: z.nativeEnum(RoleID).optional().nullable(),
});

export const adminDashMembersSchema = z.object({
  all_user_ids: z.number().array(),
  non_admin_user_ids: z.number().array(),
  results: adminDashUserSchema.array(),
  total: z.number(),
});

/*
 * Originally these schemas extended the adminDashUserSchema, but form validation required too many
 * minute changes to the fields (minimum lengths, everything has to be a string), and trying to extend
 * the original schema with all those changes resulted in some pretty bizarre field orders in the relevant forms.
 */
export const schoolMemberForm = z.object({
  name: z.string().min(1),
  last_name: z.string().min(1),
  email: z.string().email(),
  role_id: z
    .literal(RoleID.Teacher.toString())
    .or(z.literal(RoleID.Student.toString())),
});
/**
 * At the moment, this schema is hypothetical and used for display more than anything else. "Regular"
 * users should not be editable in the current state of the admin dashboard.
 */
export const regularMemberForm = z.object({
  name: z.string().min(1),
  last_name: z.string().min(1),
  username: z.string().min(1),
  bio: z.string().optional(),
});

export const adminDashImportStatusSchema = z.object({
  percent_complete: z.number(),
  num_complete: z.number(),
  num_total: z.number(),
  errored_emails: z.string().array().optional().nullable(),
});

export type AdminDashUser = z.infer<typeof adminDashUserSchema>;
export type SchoolMember = z.infer<typeof schoolMemberForm>;
export type RegularMember = z.infer<typeof regularMemberForm>;
export type AdminDashMembers = z.infer<typeof adminDashMembersSchema>;
